// Auto-generated normalizer for table: Instructor
export function instructorNormalize(row) {
  return {
    idInstructor: row.idInstructor ?? row.IdInstructor ?? row['IdInstructor'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['IdEmpleado'] ?? 0,
    numeroCertificacion: row.numeroCertificacion ?? row.NumeroCertificacion ?? row['NumeroCertificacion'] ?? '',
    descripcionCertificacion: row.descripcionCertificacion ?? row.DescripcionCertificacion ?? row['DescripcionCertificacion'] ?? '',
    institucionQueCertifica: row.institucionQueCertifica ?? row.InstitucionQueCertifica ?? row['InstitucionQueCertifica'] ?? '',
    avatarUrl: row.avatarUrl ?? row.AvatarUrl ?? row['AvatarUrl'] ?? '',
    bannerUrl: row.bannerUrl ?? row.BannerUrl ?? row['BannerUrl'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? row['IdEmpresa'] ?? null,
    nombreEmpresa: row.nombreEmpresa ?? row.NombreEmpresa ?? row['NombreEmpresa'] ?? 'N/A',
    notificacionesCursos: row.notificacionesCursos ?? row.NotificacionesCursos ?? row['NotificacionesCursos'] ?? false,
  };
}
